import React from 'react'

import Popover from '@material-ui/core/Popover'
import PropTypes from 'prop-types'

class ContextMenu extends React.PureComponent {
  // Make sure that the click event does not bubble up and trigger
  // a layer visibility change for example
  onClick = (event) => {
    event.stopPropagation()
  }

  onContextMenu = (event) => {
    const { onClose } = this.props

    // Avoid showing default context menu
    event.preventDefault()

    // Close context menu
    onClose(event)
  }

  render = () => {
    const { children, onClose, position, show } = this.props

    // console.debug('ContextMenu - render', show, position)

    return (
      <Popover
        keepMounted={false}
        open={show}
        onClick={this.onClick}
        onClose={onClose}
        onContextMenu={this.onContextMenu}
        anchorReference="anchorPosition"
        anchorPosition={position}
      >
        { children }
      </Popover>
    )
  }
}

ContextMenu.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  show: PropTypes.bool.isRequired,
  position: PropTypes.object
}

export default ContextMenu
